// Navbar — ported from the US Shopify theme's assets/main.js (same
// mechanics: circle-reveal mobile menu measured from the toggle's real
// position, one dropdown state machine for both the desktop panel and the
// mobile accordion). EU: the language switcher reuses the same dropdown
// class, so it's picked up automatically.
const navToggle = document.getElementById("navToggle");

if (navToggle) {
  const navbar = navToggle.closest(".navbar");
  const navLinks = document.getElementById("navLinks");

  const setMenuOrigin = function () {
    const r = navToggle.getBoundingClientRect();
    navLinks.style.setProperty("--menu-origin-x", `${r.left + r.width / 2}px`);
    navLinks.style.setProperty("--menu-origin-y", `${r.top + r.height / 2}px`);
  };

  const setNavOpen = function (open) {
    if (open) setMenuOrigin();
    navbar.classList.toggle("nav-open", open);
    navToggle.setAttribute("aria-expanded", String(open));
    navToggle.setAttribute("aria-label", open ? "Zamknij menu" : "Otwórz menu");
    document.body.style.overflow = open ? "hidden" : "";
  };

  navToggle.addEventListener("click", () => {
    setNavOpen(navToggle.getAttribute("aria-expanded") !== "true");
  });

  navbar.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && navbar.classList.contains("nav-open")) {
      setNavOpen(false);
      navToggle.focus();
    }
  });

  navLinks.addEventListener("click", (e) => {
    if (e.target.closest(".navbar__links-trigger")) return;
    if (e.target.closest("a")) setNavOpen(false);
  });

  // Resizing past the breakpoint with the menu open would otherwise leave
  // the page scroll-locked behind a now-hidden overlay.
  window.matchMedia("(min-width: 1101px)").addEventListener("change", (e) => {
    if (e.matches) setNavOpen(false);
  });

  const items = document.querySelectorAll(".navbar__links-item--has-dropdown");

  const closeAllDropdowns = function (except) {
    items.forEach((item) => {
      if (item === except) return;
      item.classList.remove("is-open");
      item.querySelector(".navbar__links-trigger")?.setAttribute("aria-expanded", "false");
    });
  };

  items.forEach((item) => {
    const trigger = item.querySelector(".navbar__links-trigger");
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const isOpen = item.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", String(isOpen));
      closeAllDropdowns(item);
    });
  });

  document.addEventListener("click", (e) => {
    if (!(e.target instanceof Element && e.target.closest(".navbar__links-item--has-dropdown"))) closeAllDropdowns();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAllDropdowns();
  });
}

// Hero video — pause/play control, and respect reduced-motion by starting
// paused (the first frame still shows as a still background).
const heroVideo = document.getElementById("heroVideo");
const heroVideoToggle = document.getElementById("heroVideoToggle");

if (heroVideo && heroVideoToggle) {
  const syncToggle = function () {
    const paused = heroVideo.paused;
    heroVideoToggle.setAttribute("aria-pressed", String(paused));
    heroVideoToggle.setAttribute("aria-label", paused ? "Odtwórz wideo" : "Zatrzymaj wideo");
  };

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    heroVideo.removeAttribute("autoplay");
    heroVideo.pause();
  }

  heroVideoToggle.addEventListener("click", () => {
    if (heroVideo.paused) heroVideo.play();
    else heroVideo.pause();
  });

  heroVideo.addEventListener("play", syncToggle);
  heroVideo.addEventListener("pause", syncToggle);
  syncToggle();
}

/* OPTION 2 (16.09.2026) - dropdown panels. Opening = .is-mega-open on the
   shell plus .is-active on one panel; the panel is anchored under its
   trigger by --mega-x (see position()). Switching tabs slides the panel
   across and swaps its content, after navbarcorporate.framer.website.
   Desktop only; below 1101px the ported mobile accordion still runs. */
(function () {
  const shell = document.getElementById("navShell");
  const mega = document.getElementById("navMega");
  if (!shell || !mega) return;

  const desktop = window.matchMedia("(min-width: 1101px)");
  const triggers = [...shell.querySelectorAll("[data-mega]")];
  const panels = [...mega.querySelectorAll(".mega")];
  let current = null;
  let closeTimer;

  // The panel is only as wide as its own content, so its left offset is
  // measured after the panel is shown, then clamped to the bar's edges -
  // the widest panel under the last tab would otherwise hang off-screen.
  const position = function (trigger) {
    const shellBox = shell.getBoundingClientRect();
    const triggerBox = trigger.getBoundingClientRect();
    const width = mega.offsetWidth;
    const wanted = triggerBox.left - shellBox.left - 16;
    const x = Math.max(0, Math.min(wanted, shellBox.width - width));
    mega.style.setProperty("--mega-x", `${Math.round(x)}px`);
  };

  const open = function (name) {
    clearTimeout(closeTimer);
    if (!desktop.matches) return;
    const trigger = triggers.find((t) => t.dataset.mega === name);
    current = name;
    panels.forEach((p) => p.classList.toggle("is-active", p.dataset.panel === name));
    triggers.forEach((t) => t.setAttribute("aria-expanded", String(t.dataset.mega === name)));
    if (trigger) position(trigger);
    shell.classList.add("is-mega-open");
    mega.setAttribute("aria-hidden", "false");
  };

  const close = function () {
    current = null;
    shell.classList.remove("is-mega-open");
    mega.setAttribute("aria-hidden", "true");
    triggers.forEach((t) => t.setAttribute("aria-expanded", "false"));
    // Panel stays mounted through the fade-out so it does not vanish
    // mid-animation.
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      if (!current) panels.forEach((p) => p.classList.remove("is-active"));
    }, 220);
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("pointerenter", () => open(trigger.dataset.mega));
    trigger.addEventListener("focus", () => open(trigger.dataset.mega));
    trigger.addEventListener("click", (e) => {
      if (!desktop.matches) return;
      e.preventDefault();
      if (current === trigger.dataset.mega) close();
      else open(trigger.dataset.mega);
    });
  });

  // Hovering a plain link closes whatever is open, same as the reference.
  shell.querySelectorAll(".navbar__links a:not([data-mega])").forEach((link) => {
    link.addEventListener("pointerenter", close);
  });

  shell.addEventListener("pointerleave", close);
  shell.addEventListener("focusout", (e) => {
    if (!shell.contains(e.relatedTarget)) close();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && current) {
      const trigger = triggers.find((t) => t.dataset.mega === current);
      close();
      trigger?.focus();
    }
  });

  desktop.addEventListener("change", (e) => {
    if (!e.matches) close();
  });
})();

/* OPTION 2 (16.09.2026) — letter-roll hover on the CTAs, after
   nubo.framer.website. Each letter becomes an overflow-hidden window with two
   stacked copies; CSS slides the stack up on hover with a per-letter delay.
   The original label goes to aria-label and the split markup is hidden from
   assistive tech, so screen readers still read one clean string. */
(function () {
  const targets = document.querySelectorAll(
    ".btn, .navbar--card .navbar__cta, .mega__btn"
  );

  targets.forEach((el) => {
    // Buttons with icons inside (svg etc.) keep their markup untouched.
    if (el.children.length || el.querySelector(".btn-roll")) return;
    const label = el.textContent.trim().replace(/\s+/g, " ");
    if (!label) return;

    el.setAttribute("aria-label", label);

    const roll = document.createElement("span");
    roll.className = "btn-roll";
    roll.setAttribute("aria-hidden", "true");

    [...label].forEach((char, i) => {
      const window_ = document.createElement("span");
      window_.className = "btn-roll__char";

      const stack = document.createElement("span");
      stack.className = "btn-roll__stack";
      stack.style.setProperty("--i", String(i));

      // Two copies: the visible one and the one waiting a line below.
      for (let copy = 0; copy < 2; copy++) {
        const line = document.createElement("span");
        line.textContent = char;
        stack.appendChild(line);
      }

      window_.appendChild(stack);
      roll.appendChild(window_);
    });

    el.textContent = "";
    el.appendChild(roll);
  });
})();

/* OPTION 2 (16.09.2026) — navbar glass/white swap. The bar is glass while the
   top of the hero is in view and becomes the white card once past it, so the
   white block stops competing with the headline. Watched with an
   IntersectionObserver on a sentinel rather than a scroll listener. */
(function () {
  const shell = document.getElementById("navShell");
  const sentinel = document.getElementById("navSentinel");
  if (!shell || !sentinel) return;

  new IntersectionObserver(
    ([entry]) => shell.classList.toggle("is-scrolled", !entry.isIntersecting),
    { threshold: 0 }
  ).observe(sentinel);
})();

/* Sekcja „Co wdrażamy" — przełączanie zakładek (16.09.2026). Wzorzec WAI-ARIA
   Tabs: klik przełącza, strzałki lewo/prawo chodzą po zakładkach, Home/End
   skaczą na skraje. Aktywna zakładka jest jedyną w tab orderze (roving
   tabindex), więc Tab wychodzi z paska do treści panelu, a nie przez trzy
   przyciski. Bez JS widoczny zostaje pierwszy panel — reszta ma `hidden`
   w HTML-u, co jest świadomym kompromisem: treść dwóch paneli jest wtedy
   nieosiągalna, ale prototyp i tak nie działa bez main.js (navbar, mega). */
(function () {
  document.querySelectorAll("[data-platform-tabs]").forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    if (tabs.length !== panels.length || !tabs.length) return;

    const select = function (index, focus) {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute("aria-selected", active ? "true" : "false");
        tab.tabIndex = active ? 0 : -1;
        panels[i].hidden = !active;
      });
      if (focus) tabs[index].focus();
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener("click", () => select(i, false));
      tab.addEventListener("keydown", (e) => {
        const last = tabs.length - 1;
        let next = null;
        if (e.key === "ArrowRight") next = i === last ? 0 : i + 1;
        else if (e.key === "ArrowLeft") next = i === 0 ? last : i - 1;
        else if (e.key === "Home") next = 0;
        else if (e.key === "End") next = last;
        if (next === null) return;
        e.preventDefault();
        select(next, true);
      });
    });

    select(Math.max(0, tabs.findIndex((t) => t.getAttribute("aria-selected") === "true")), false);
  });
})();

/* 18.09.2026 — wejście treści przy przewijaniu na PODSTRONACH (redesign,
   gpt-taste: „staggered entry"). Strona główna ma własne [data-reveal]
   w home.js, więc tu jej nie ruszamy. Elementy, które już są w kadrze
   przy wczytaniu, pojawiają się od razu; przy prefers-reduced-motion
   i bez IntersectionObservera nic nie jest ukrywane. */
(function () {
  if (document.body.classList.contains("home")) return;
  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const selector = [
    ".section__head", ".glance__inner", ".card", ".evidence__item",
    ".steps__item", ".faq details", ".citations li", ".audience__item",
    ".mechanism__grid > *", ".split > *", ".ctaband__inner", ".pubs__item",
    ".platform__intro", ".note",
    ".ja-head", ".ja-step", ".ja-tile", ".ja-counter", ".ja-quote",
    ".ja-plan", ".ja-post", ".ja-faq__item", ".ja-intel__media", ".ja-story",
  ].join(",");

  const items = [...document.querySelectorAll(selector)].filter(
    (el) => !el.closest(".pagehero, .navshell, .footer, .wf")
  );
  if (!items.length) return;

  // Opóźnienie liczone w obrębie rodzeństwa, żeby rząd kart wchodził
  // kaskadowo, a nie cała strona po kolei.
  items.forEach((el) => {
    const siblings = [...el.parentElement.children].filter((c) => items.includes(c));
    el.style.setProperty("--rv-i", String(Math.min(siblings.indexOf(el), 5)));
    el.classList.add("rv");
  });

  document.documentElement.classList.add("js-reveal");

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);
      });
    },
    { rootMargin: "0px 0px -8% 0px", threshold: 0.05 }
  );

  items.forEach((el) => io.observe(el));
})();
